"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconTextColor', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9.40276 7.94805L10.0031 10H12L9.01072 1H6.98928L4 10H5.92343L6.49923 7.94805H9.40276ZM9.02297 6.54545H6.89127L7.94487 2.77922L9.02297 6.54545ZM14 11H2V15H14V11Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12.0979 11.0361L12.9921 14H15.9667L11.5139 1H8.50283L4.05005 14H6.91516L7.77287 11.0361H12.0979ZM11.5322 9.0101H8.35684L9.92626 3.56998L11.5322 9.0101ZM18 15H2V19H18V15Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M14.584 14.1241L15.6899 18H19.3684L13.8619 1H10.1381L4.63158 18H8.17474L9.23543 14.1241H14.584ZM13.8844 11.4747H9.9576L11.8984 4.36075L13.8844 11.4747ZM22 19H2V23H22V19Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M20.7573 23L19.3315 17.9841H12.4357L11.0681 23H6.5L13.5995 1H18.4005L25.5 23H20.7573zM13.3668 14.5556H18.4296L15.8691 5.34921 13.3668 14.5556zM3 25H29V31H3z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;